export default __webpack_public_path__ + "static/media/Logo.c11feba3.svg";